import React from "react";
import { Form, Input, Spin } from "antd";
import { EComModal } from "components/EComModal";
import { AiccLessonInformation, AiccLessonInformationPayload } from "types/model/aiccLearningAssets";
import { trimValues, useAssetFormModal } from "../hooks/useAssetFormModal";
import styles from "./LessonInformation.module.scss";

interface Props {
  visible: boolean;
  lesson?: AiccLessonInformation;
  isSaving: boolean;
  onCancel: () => void;
  onSubmit: (payload: AiccLessonInformationPayload) => void;
}

const toFormValues = (lesson?: AiccLessonInformation) => ({
  summary: lesson?.summary,
  keyVocabulary: lesson?.keyVocabulary,
});

function LessonInformationModal({ visible, lesson, isSaving, onCancel, onSubmit }: Props) {
  const form = useAssetFormModal<AiccLessonInformationPayload, AiccLessonInformation>(visible, lesson, toFormValues);

  const handleOk = () => form.validateFields().then((values) => onSubmit(trimValues(values)));

  return (
    <EComModal
      visible={visible}
      width={800}
      title="Edit Lesson Information"
      okText="Save"
      onOk={handleOk}
      onCancel={onCancel}
      isSaving={isSaving}
    >
      <Spin spinning={isSaving} size="large">
        <div className={styles.lessonRef}>
          <span className={styles.lessonRefLabel}>Level:</span>
          {lesson?.level}
        </div>
        <div className={styles.lessonRef}>
          <span className={styles.lessonRefLabel}>Lesson:</span>
          {lesson?.lesson}
        </div>
        <Form form={form} layout="vertical">
          <Form.Item
            label="Lesson Summary"
            name="summary"
            rules={[{ required: true, whitespace: true, message: "Please enter a lesson summary." }]}
          >
            <Input.TextArea rows={8} showCount placeholder="Lesson Summary" />
          </Form.Item>
          <Form.Item
            label="Key Vocabulary"
            name="keyVocabulary"
            rules={[{ required: true, whitespace: true, message: "Please enter key vocabulary." }]}
          >
            <Input.TextArea rows={5} showCount placeholder="Key Vocabulary" />
          </Form.Item>
        </Form>
      </Spin>
    </EComModal>
  );
}

export default LessonInformationModal;
